export default {
  app: {
    language: process.env.REACT_APP_DEFAULT_LANGUAGE,
    currency: 'eur',
    isLogged: false,
    reference: '',
    balance: 0,
    globalErrorVisible: false,
  },
  faq: {
    mostSearched: [],
    categories: [],
    questions: [],
    searchResults: [],
    answer: {},
  },
  user: {
    type: null, // investor | debtor | onboarding-debtor | onboarding-investor | null
    step: null,
  },
  onboarding: {
    step: null, // Zmeniť z 0 na null pre kompatibilitu so stringami z API
    sending_status: null,
  },
  onboarding_document_types: [],
  mailbox: {
    emails: [],
    sms: [],
    documents: [],
    personal_requests: [],
    letters: [],
    all: [],
    reports: [],

    emailsLoading: false,
    smsLoading: false,
    allLoading: false,
    documentsLoading: false,
    requestsLoading: false,
    lettersLoading: false,
    reportsLoading: false,
    reportSubscriptionLoading: false,
  },
  dashboard: {},
  investments: {
    items: [],
    pagination: {},
  },
  offers: {
    automaticOffers: {
      items: [],
      pagination: {},
    },
    manualOffers: {
      items: [],
      pagination: {},
    },
    typesCounts: {
      automatic: 0,
      manual: 0,
    },
    automaticLoading: false,
    manualLoading: false,
  },
  secondary_market: {
    items: [],
    pagination: {},
  },
  biddings: {
    items: [],
    pagination: {},
  },
  investment_detail: {},
  instruction: {},
  resourcesOverview: {},
  deposits: {
    qrCodeString: null,
    qrCodeStringError: false,
  },
  estimates: {
    chartData: [],
    chartDataLoading: false,
  },
};
